import { TriangleAlert } from 'lucide-react';
import { useQuotes } from '../hooks/useQuotes';

interface ItemCommittedQuotesHintProps {
  itemId: string;
}

/**
 * #481 — quote-creation guard: when the selected inventory item already has
 * a quote in a committed status, warn before creating another. Warn, never
 * block — first to close wins.
 */
export function ItemCommittedQuotesHint({ itemId }: ItemCommittedQuotesHintProps) {
  const { data } = useQuotes({ inventory_item_id: itemId, committed: true, per_page: 3 });
  const committed = data?.items ?? [];

  if (committed.length === 0) return null;

  return (
    <p className="flex items-start gap-1.5 text-xs text-warning-foreground bg-warning/10 border border-warning/30 rounded-md px-2.5 py-2">
      <TriangleAlert className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span>
        This boat has a deal in progress (
        {committed
          .map((quote) => `${quote.quote_number} — ${quote.quote_status_label ?? quote.status?.name}`)
          .join(', ')}
        ). You can still create a quote — first to close wins.
      </span>
    </p>
  );
}
